import { GetBy } from '../_app/cuchillo/core/Element';

export class SpaceCardLinks {
    static _links = [];
    static _handler = null;

    static init() {
        this._links = [...document.querySelectorAll('.button[data-space-id]')];
        if (!this._links.length) return;

        this._handler = (e) => {
            const link = e.currentTarget;
            const select = GetBy.id('space');
            if (!select) return;

            const option = select.querySelector(`option[data-space-id="${link.dataset.spaceId}"]`);
            if (!option) return;

            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        };

        this._links.forEach((link) => link.addEventListener('click', this._handler));
    }

    static dispose() {
        this._links.forEach((link) => link.removeEventListener('click', this._handler));
        this._links = [];
    }
}
